import type { PathParams } from 'msw';

export type Factory<T> = (overrides?: Partial<T>) => T;

export type MswArgs = {
  params: PathParams;
  request: Request;
};

export const randomId = () => `${Math.round(Math.random() * 10000000000)}`;
export const randomUuid = () => crypto.randomUUID();
